import type { TemplateDto } from "@/modules/template/gateway/templateDto"
import { TemplateCategoryEntity } from "@/modules/template/entities/templateCategoryEntity"
import type { TemplateType } from "@/modules/template/types/templateType"

export class TemplateEntity {
  id: string
  name: string
  description: string | null
  templateCategory: TemplateCategoryEntity | null
  creationDate: string
  lastUpdateDate: string
  templateType: TemplateType

  private constructor(template: TemplateEntity) {
    this.id = template.id
    this.name = template.name
    this.description = template.description
    this.templateCategory = template.templateCategory
    this.creationDate = template.creationDate
    this.lastUpdateDate = template.lastUpdateDate
    this.templateType = template.templateType
  }

  static fromDto(dto: TemplateDto): TemplateEntity {
    return new TemplateEntity({
      id: dto.id,
      name: dto.name,
      description: dto.description,
      templateCategory: dto.templateCategory ? TemplateCategoryEntity.fromDto(dto.templateCategory) : null,
      creationDate: dto.creationDate,
      lastUpdateDate: dto.lastUpdateDate,
      templateType: dto.templateType,
    })
  }
}
